// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"b47d9673","455":"9eb6c8a6","715":"61413069","955":"e597c810"}[chunkId] + ".css";
};